/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const LayoutMode = {
    ImageBased: 'ImageBased',
    SlotBased: 'SlotBased',
    ComponentBased: 'ComponentBased'
} as const;
export type LayoutMode = typeof LayoutMode[keyof typeof LayoutMode];

